import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'ChangelogDetails' })((theme) => ({
    root: {
        position: 'relative',
        display: 'grid',
        gridTemplateAreas: '"summaries main toc"',
        gridTemplateColumns: '200px 1fr 200px',
        gap: 120,
        alignItems: 'start',
        marginTop: 40,
        marginBottom: 96,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 16,
            gridTemplateAreas: `
                "toc"
                "main"
            `,
            gap: 40,
            gridTemplateColumns: '1fr'
        }
    },
    summaries: {
        gridArea: 'summaries'
    },
    main: {
        gridArea: 'main'
    },
    toc: {
        gridArea: 'toc',
        position: 'sticky',
        top: 120,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            position: 'static'
        }
    },
    date: {
        fontSize: 32,
        fontWeight: 700,
        lineHeight: '120%',
        letterSpacing: '-0.96px'
    },
    divider: {
        backgroundColor: '#ECECEC',
        height: 1,
        border: 0,
        marginBottom: 48,
        marginTop: 48,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginBottom: 40,
            marginTop: 40
        }
    }
}));
